/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Route, Redirect, RouteProps, useLocation } from 'react-router-dom';

import { useChallengeCookie } from 'id-utils/login';

export namespace CookieMatchedRoute {
  export type Props = RouteProps & { redirectUrlOnFailedCookie?: string };
}

export const CookieMatchedRoute: React.FC<CookieMatchedRoute.Props> = ({
  children,
  redirectUrlOnFailedCookie,
  ...otherRouteProps
}) => {
  const { pathname } = useLocation();
  const challengeCookieResult = useChallengeCookie();
  const routeContent = (() => {
    // if bad/missing cookie, reset flow
    if (challengeCookieResult.type === 'failure') {
      if (!redirectUrlOnFailedCookie) return children;
      return <Redirect to={redirectUrlOnFailedCookie} />;
    }
    const expectedUrl = challengeCookieResult.cookie?.expectedUrl;
    // if they are navigating to wrong page based on cookie, snap them to their previous position in auth flow
    if (expectedUrl && pathname !== expectedUrl) {
      return <Redirect to={expectedUrl} />;
    }
    return children;
  })();
  return <Route {...otherRouteProps}>{routeContent}</Route>;
};
